import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Modal, Row, Col, Card, Spinner } from "react-bootstrap";
import Select from "react-select";
import MyApiClient from '../../../../api-client/MyApiClient';
import { italianProvinces } from '../../Util/enum';

const langOptions = [
    { value: "ar", label: "Arabo" },
    { value: "de", label: "Tedesco" },
    { value: "en", label: "Inglese" },
    { value: "it", label: "Italiano" },
    { value: "es", label: "Spagnolo" },
    { value: "fr", label: "Francese" },
    { value: "ru", label: "Russo" }
];

const optionsTipologia = [
    { value: "ASD", label: "ASD" },
    { value: "SSD", label: "SSD" },
    //{ value: "FREELANCER", label: "Libero professionista" },
    { value: "INDIVIDUAL_COMPANY", label: "Ditta individuale" },
    { value: "CAPITAL_COMPANY", label: "SRL / SPA" },
  ];

  const subOptions = [
    { value: "SCHOOL", label: "Scuola" },
    { value: "GYM", label: "Palestra" },
    { value: "RENTAL_SHOP", label: "Rental Shop" },
    { value: "CIRCLE", label: "Club" },
    { value: "SPORTS_CLUB", label: "Società Sportiva" },
  ];

const FormIDS = (props) => {

    const [profile, setProfile] = useState(props.profile);

    const [formData, setFormData] = useState({
        name: '',
        phoneNumber: '',
        languages: [],
        vatNumber: '',
        taxCode: '',
        incorporationYear: '',
        bookingUrl: '',
        description: '',
        legalRepresentativeId: '',
        legalRepresentativeFirstName: '',
        legalRepresentativeLastName: '',
        legalRepresentativeBirthPlace: '',
        legalRepresentativeCity: '',
        legalRepresentativeAddress: '',
        legalRepresentativeTaxCode: '',
        streetAddress: '',
        locality: '',
        country: '',
        postalCode: '',
        province: '',
        legalStreetAddress: '',
        legalLocality: '',
        legalCountry: '',
        legalPostalCode: '',
        legalProvince: '',
        referralId: '',
        email: ''
    });

    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');
    const [loadingShowed, setLoadingShowed] = useState(false);
    const [initialClubNature, setInitialClubNature] = useState('');

    const [memberOptions, setMemberOptions] = useState([]);

    const [isLegalRepresentativeNotMember, setIsLegalRepresentativeNotMember] = useState(true);
    const handleCheckboxChange = (event) => {
        setIsLegalRepresentativeNotMember(event.target.checked);
    };

    const [isLegalEqualsToOperativa, setIsLegalEqualsToOperativa] = useState(false);
    const handleCheckboxChange2 = (event) => {
        setIsLegalEqualsToOperativa(event.target.checked);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSelectChange = (selectedOptions) => {
        const selectedLanguages = selectedOptions.map(option => option.value);
        setFormData(prevState => ({
            ...prevState,
            languages: selectedLanguages
        }));
    };

    const handleSelectTipologiaStruttura = (selectedOptions) => {
		setFormData(prevState => ({
            ...prevState,
            clubNature: selectedOptions.value
        }));
    };

    const handleSelectSubTipologiaStruttura = (selectedOptions) => {
		setFormData(prevState => ({
            ...prevState,
            clubSubNature: selectedOptions.value
        }));
    };

    const handleSelectMemberStruttura = (selectedOptions) => {
		setFormData(prevState => ({
            ...prevState,
            legalRepresentativeId: selectedOptions.value
        }));
    };

    const handleSaveClick = (e) => {
        e.preventDefault();

        // Validation check
        let errors = [];
        if (!formData.name) errors.push('Nome');
        if (!formData.phoneNumber) errors.push('Telefono');
        if (formData.languages.length === 0) errors.push('Lingue parlate');
        if (!formData.incorporationYear) errors.push('Anno di costituzione');
        if (!formData.clubNature) errors.push('Tipologia giuridica');
        if (!formData.clubSubNature) errors.push('Natura struttura');
        // Sempre obbligatori nome e cognome del rappresentante legale
        if (!formData.legalRepresentativeFirstName) errors.push('Nome rappresentante legale');
        if (!formData.legalRepresentativeLastName) errors.push('Cognome rappresentante legale');
        if (!formData.legalRepresentativeBirthPlace) errors.push('Luogo di nascita rappresentante legale');
        if (!formData.legalRepresentativeCity) errors.push('Città rappresentante legale');
        if (!formData.legalRepresentativeAddress) errors.push('Indirizzo rappresentante legale');
        if (!formData.legalRepresentativeTaxCode) errors.push('Codice Fiscale rappresentante legale');
        if (!formData.streetAddress) errors.push('Via sede operativa');
        if (!formData.locality) errors.push('Località sede operativa');
        if (!formData.province) errors.push('Provincia sede operativa');
        if (!formData.postalCode) errors.push('CAP sede operativa');
        if (!isLegalEqualsToOperativa) {
            if (!formData.legalStreetAddress) errors.push('Via sede legale');
            if (!formData.legalLocality) errors.push('Località sede legale');
            if (!formData.legalProvince) errors.push('Provincia sede legale');
            if (!formData.legalPostalCode) errors.push('CAP sede legale');
        }

        if (errors.length > 0) {
            setModalTitle("Errore di validazione");
            setModalText(`I seguenti campi obbligatori non sono compilati: ${errors.join(', ')}`);
            setModalShowed(true);
            return;
        }

        const saveData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    let profile_send = JSON.parse(JSON.stringify(props.profile));

                    profile_send.club.name = formData.name;
                    profile_send.club.phoneNumber = formData.phoneNumber;
                    profile_send.club.incorporationYear = formData.incorporationYear;
                    profile_send.club.bookingUrl = formData.bookingUrl;
                    profile_send.club.description = formData.description;
                    profile_send.club.legalRepresentativeId = formData.legalRepresentativeId!=='' ? formData.legalRepresentativeId : null;
                    profile_send.club.legalRepresentativeFirstName = formData.legalRepresentativeFirstName;
                    profile_send.club.legalRepresentativeLastName = formData.legalRepresentativeLastName;
                    profile_send.club.legalRepresentativeBirthPlace = formData.legalRepresentativeBirthPlace;
                    profile_send.club.legalRepresentativeCity = formData.legalRepresentativeCity;
                    profile_send.club.legalRepresentativeAddress = formData.legalRepresentativeAddress;
                    profile_send.club.legalRepresentativeTaxCode = formData.legalRepresentativeTaxCode;
                    
                    profile_send.club['address'] = {}
                    profile_send.club.address.streetAddress = formData.streetAddress;
                    profile_send.club.address.locality = formData.locality;
                    profile_send.club.address.country = 'Italia';
                    profile_send.club.address.postalCode = formData.postalCode;
                    profile_send.club.address.province = formData.province;

                    profile_send.club['legalAddress'] = {}
                    if(isLegalEqualsToOperativa) {
                        profile_send.club.legalAddress.streetAddress = formData.streetAddress;
                        profile_send.club.legalAddress.locality = formData.locality;
                        profile_send.club.legalAddress.country = 'Italia';
                        profile_send.club.legalAddress.postalCode = formData.postalCode;
                        profile_send.club.legalAddress.province = formData.province;
                    } else {
                        profile_send.club.legalAddress.streetAddress = formData.legalStreetAddress;
                        profile_send.club.legalAddress.locality = formData.legalLocality;
                        profile_send.club.legalAddress.country = 'Italia';
                        profile_send.club.legalAddress.postalCode = formData.legalPostalCode;
                        profile_send.club.legalAddress.province = formData.legalProvince;
                    }

                    profile_send.club.spokenLocales = formData.languages;
                    profile_send.club.clubNature = formData.clubNature;
                    profile_send.club.clubSubNature = formData.clubSubNature;

                    delete profile_send.club.logo;
                    delete profile_send.club.pictures;

                    setLoadingShowed(true);
                    const saveResult = await apiClient.updateProfile(token, profile_send);
                    setLoadingShowed(false);

                    if (saveResult && saveResult.error) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
                        setModalShowed(true);
                    } else {
                        // Mantieni allineato clubNature in sessionStorage così la voce di menu
                        // "Organismo sociale" compare subito, senza dover rifare login.
                        try {
                            const tokenDetailsString = sessionStorage.getItem('userDetails');
                            if (tokenDetailsString) {
                                const tokenDetails = JSON.parse(tokenDetailsString);
                                tokenDetails.clubNature = formData.clubNature;
                                sessionStorage.setItem('userDetails', JSON.stringify(tokenDetails));
                            }
                        } catch (e) {
                            console.error('Impossibile aggiornare clubNature in sessionStorage:', e);
                        }
                        window.location.reload();
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        saveData();
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    const [membershipDataUsers] = await Promise.all([
                        apiClient.getMemberships(token,'MEMBER',null,'CONFIRMED')
                    ]);

                    if(membershipDataUsers) {
						let data_member = [];
						membershipDataUsers.forEach(element => {
							let member_row = {
								"value": element.userId,
								"label": element.name
							};
							data_member.push(member_row);
						})

						setMemberOptions(data_member);
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {

        if (props.profile && props.profile.club) {
            let structureData = props.profile;

            setProfile(structureData);

            if (structureData && structureData.club) {
                let myFormData = {};
                myFormData.name = structureData.club.name ? structureData.club.name : '';
                myFormData.email = structureData.club.email ? structureData.club.email : '';
                myFormData.referralId = structureData.club.referralId ? structureData.club.referralId : '';
                myFormData.phoneNumber = structureData.club.phoneNumber ? structureData.club.phoneNumber : '';
                myFormData.languages = structureData.club.spokenLocales ? structureData.club.spokenLocales : [];
                myFormData.clubNature = structureData.club.clubNature ? structureData.club.clubNature : '';
                if(structureData.club.clubNature) {
                    setInitialClubNature(structureData.club.clubNature);
                }
                myFormData.clubSubNature = structureData.club.clubSubNature ? structureData.club.clubSubNature : '';
                myFormData.vatNumber = structureData.club.vatNumber ? structureData.club.vatNumber : '';
                myFormData.taxCode = structureData.club.taxCode ? structureData.club.taxCode : '';
                myFormData.incorporationYear = structureData.club.incorporationYear ? structureData.club.incorporationYear : null;
                myFormData.bookingUrl = structureData.club.bookingUrl ? structureData.club.bookingUrl : '';
                myFormData.description = structureData.club.description ? structureData.club.description : '';
                myFormData.legalRepresentativeId = structureData.club.legalRepresentativeId ? structureData.club.legalRepresentativeId : '';
                myFormData.legalRepresentativeFirstName = structureData.club.legalRepresentativeFirstName ? structureData.club.legalRepresentativeFirstName : '';
                myFormData.legalRepresentativeLastName = structureData.club.legalRepresentativeLastName ? structureData.club.legalRepresentativeLastName : '';
                myFormData.legalRepresentativeBirthPlace = structureData.club.legalRepresentativeBirthPlace ? structureData.club.legalRepresentativeBirthPlace : '';
                myFormData.legalRepresentativeCity = structureData.club.legalRepresentativeCity ? structureData.club.legalRepresentativeCity : '';
                myFormData.legalRepresentativeAddress = structureData.club.legalRepresentativeAddress ? structureData.club.legalRepresentativeAddress : '';
                myFormData.legalRepresentativeTaxCode = structureData.club.legalRepresentativeTaxCode ? structureData.club.legalRepresentativeTaxCode : '';
                myFormData.streetAddress = structureData.club.address ? structureData.club.address.streetAddress : '';
                myFormData.locality = structureData.club.address ? structureData.club.address.locality : '';
                myFormData.country = structureData.club.address ? structureData.club.address.country : '';
                myFormData.postalCode = structureData.club.address ? structureData.club.address.postalCode : '';
                myFormData.province = structureData.club.address ? structureData.club.address.province : '';
                myFormData.legalStreetAddress = structureData.club.legalAddress ? structureData.club.legalAddress.streetAddress : '';
                myFormData.legalLocality = structureData.club.legalAddress ? structureData.club.legalAddress.locality : '';
                myFormData.legalCountry = structureData.club.legalAddress ? structureData.club.legalAddress.country : '';
                myFormData.legalPostalCode = structureData.club.legalAddress ? structureData.club.legalAddress.postalCode : '';
                myFormData.legalProvince = structureData.club.legalAddress ? structureData.club.legalAddress.province : '';

                if(myFormData.streetAddress === myFormData.legalStreetAddress && myFormData.locality === myFormData.legalLocality &&
                    myFormData.country === myFormData.legalCountry && myFormData.postalCode === myFormData.legalPostalCode && myFormData.province === myFormData.legalProvince) {
                        
                        setIsLegalEqualsToOperativa(true);
                }

                // Sempre abilitato - Il rappresentante legale non fa parte dei soci
                setIsLegalRepresentativeNotMember(true);

                setFormData(myFormData);
            }
        }

    }, [props]);


    return (
        <>
            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-12">
                    <Card>
                        <Card.Header><h4 className="card-title">IDS</h4></Card.Header>
                        <Card.Body>
                            <Form>
                                <Row>
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2">Nome Struttura</Form.Label>
                                        <Form.Control style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'Inserisci Nome'} type="text" name="name" value={formData.name} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2">Telefono</Form.Label>
                                        <Form.Control style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            borderColor: formData.phoneNumber ? '#ced4da' : '#ff0000',
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'Inserisci Telefono'} type="text" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2">Email</Form.Label>
                                        <Form.Control 
                                            style={{
                                                color: 'rgba(108,117,125,0.6)', 
                                                backgroundColor: '#f2f2f2', 
                                                paddingLeft: "15px",
                                                marginTop: "8px", 
                                                fontWeight: "normal" 
                                            }} 
                                            placeholder=""
                                            type="email" 
                                            name="email" 
                                            value={formData.email} 
                                            onChange={handleChange} 
                                            disabled={true} 
                                        />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Lingue parlate</Form.Label>
                                        <Select
                                            placeholder="Seleziona lingue"
                                            value={langOptions.filter(option => formData.languages.includes(option.value))}
                                            isMulti
                                            options={langOptions}
                                            onChange={handleSelectChange}
                                            isDisabled={props.isDisabled}
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    borderColor: formData.languages.length === 0 ? '#ff0000' : '#ced4da',
                                                    color: "#000000",
                                                    paddingLeft: "15px",
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label>Tipologia giuridica</Form.Label>
                                        <Select
                                            isDisabled={props.isDisabled || !!initialClubNature}
                                            placeholder="Seleziona la tipologia"
                                            value={optionsTipologia.filter(option => formData.clubNature === option.value)}
                                            onChange={handleSelectTipologiaStruttura}
                                            options={optionsTipologia}
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    borderColor: formData.clubNature === '' ? '#ff0000' : '#ced4da',
                                                    color: "#000000",
                                                    paddingLeft: "15px",
                                                })
                                            }}
                                        />
                                        {!formData.clubNature && (
                                            <div className="alert alert-warning mt-2 p-2 fs-14" role="alert" style={{color: 'black'}}>
                                                <strong>Attenzione!</strong> Una volta scelta la tua tipologia giuridica non potrai più modificarla.
                                            </div>
                                        )}
                                    </Col>
                                    <Col className='col-xl-6'>
                                        <Form.Label>Natura struttura</Form.Label>
                                        <Select
                                            isDisabled={props.isDisabled}
                                            placeholder="Seleziona la natura"
                                            value={subOptions.filter(option => formData.clubSubNature === option.value)}
                                            onChange={handleSelectSubTipologiaStruttura}
                                            options={subOptions}
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    borderColor: formData.clubSubNature === '' ? '#ff0000' : '#ced4da',
                                                    color: "#000000",
                                                    paddingLeft: "15px",
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2">Anno di costituzione</Form.Label>
                                        <Form.Control style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            borderColor: formData.incorporationYear ? '#ced4da' : '#ff0000',
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'Inserisci anno di costituzione'} type="text" name="incorporationYear" value={formData.incorporationYear} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label className="mb-2">URL sito web</Form.Label>
                                        <Form.Control style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'www.sitoweb.it'} type="text" name="bookingUrl" value={formData.bookingUrl} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-12">
                                        <Form.Label className="mb-2">Descrizione</Form.Label>
                                        <Form.Control rows={10} style={{
                                            color: props.isDisabled ? 'rgba(108,117,125,0.6)' : '#000000',
                                            backgroundColor: props.isDisabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: props.isDisabled ? "normal" : "normal",
                                            marginTop: props.isDisabled ? "10px" : "0px",
                                            paddingLeft: "15px"
                                        }} placeholder={props.isDisabled ? "" : 'Inserisci la descrizione della tua struttura'} as="textarea" name="description" value={formData.description} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h5>DonAction Code</h5></Card.Header>
                        <Card.Body>
                            <Row className="mt-4">
                                <Col className="col-xl-12">
                                    <Form.Control rows={10} style={{color: '#000000'}} name="referralId" value={formData.referralId?formData.referralId:'-'} disabled={true} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h5>Rappresentante legale</h5></Card.Header>
                        <Card.Body>
                            <Form>
                                {/* Campo nascosto: `checked` non ha senso su un input hidden
                                    (usa solo value) e senza onChange generava un warning React. */}
                                <input
                                    type="hidden"
                                    value={isLegalRepresentativeNotMember}
                                />
                                {/* Campi nome e cognome sempre visibili */}
                                <Row>
                                    <Col className="col-xl-6">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalRepresentativeFirstName ? '#ced4da' : '#ff0000'}} placeholder='Inserisci nome' name="legalRepresentativeFirstName" value={formData.legalRepresentativeFirstName} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Cognome</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalRepresentativeLastName ? '#ced4da' : '#ff0000'}} placeholder='Inserisci cognome' name="legalRepresentativeLastName" value={formData.legalRepresentativeLastName} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label>Luogo di nascita</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalRepresentativeBirthPlace ? '#ced4da' : '#ff0000'}} placeholder='Inserisci luogo di nascita' name="legalRepresentativeBirthPlace" value={formData.legalRepresentativeBirthPlace} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Città di residenza</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalRepresentativeCity ? '#ced4da' : '#ff0000'}} placeholder='Inserisci città di residenza' name="legalRepresentativeCity" value={formData.legalRepresentativeCity} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label>Indirizzo di residenza</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalRepresentativeAddress ? '#ced4da' : '#ff0000'}} placeholder='Inserisci indirizzo di residenza' name="legalRepresentativeAddress" value={formData.legalRepresentativeAddress} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Codice Fiscale</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalRepresentativeTaxCode ? '#ced4da' : '#ff0000'}} placeholder='Inserisci codice fiscale' name="legalRepresentativeTaxCode" value={formData.legalRepresentativeTaxCode} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h5>Sede operativa</h5></Card.Header>
                        <Card.Body>
                            <Form>
                                <Row>
                                    <Col className="col-xl-4">
                                        <Form.Label>Via</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.streetAddress ? '#ced4da' : '#ff0000'}} placeholder='Inserisci indirizzo' name="streetAddress" value={formData.streetAddress} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-4">
                                        <Form.Label>Località</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.locality ? '#ced4da' : '#ff0000'}} placeholder='Inserisci località' name="locality" value={formData.locality} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-4">
                                        <Form.Label>Provincia</Form.Label>
                                        <Select
                                            isDisabled={props.isDisabled ? true : false}
                                            placeholder="Seleziona la provincia"
                                            name="province"
                                            value={italianProvinces.find(o => o.value === formData.province || o.label === formData.province) || null}
                                            onChange={(selected) => setFormData(prev => ({ ...prev, province: selected ? selected.value : '' }))}
                                            options={italianProvinces}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderColor: formData.province ? '#ced4da' : '#ff0000',
                                                    color: '#000000',
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label>CAP</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.postalCode ? '#ced4da' : '#ff0000'}} placeholder='Inserisci CAP' name="postalCode" value={formData.postalCode} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Paese</Form.Label>
                                        <Form.Control
                                            style={{
                                                color: 'rgba(108,117,125,0.6)',
                                                backgroundColor: '#f2f2f2',
                                                paddingLeft: "15px",
                                                marginTop: "8px",
                                                fontWeight: "normal"
                                            }}
                                            type="text"
                                            name="country"
                                            value="Italia"
                                            disabled={true}
                                            readOnly
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h5>Sede legale</h5></Card.Header>
                        <Card.Body>
                            <Form>
                                <Row className="mt-2 mb-4">
                                    <Col className="col-xl-12">
                                        <div>
                                            <label>
                                                <input
                                                type="checkbox"
                                                checked={isLegalEqualsToOperativa}
                                                onChange={handleCheckboxChange2}
                                                disabled={props.isDisabled ? true : false}
                                                />
                                                &nbsp;&nbsp;&nbsp;Coincide con quella operativa
                                            </label>
                                        </div>
                                    </Col>
                                </Row>
                                {!isLegalEqualsToOperativa && <Row>
                                    <Col className="col-xl-4">
                                        <Form.Label>Via</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalStreetAddress ? '#ced4da' : '#ff0000'}} placeholder='Inserisci indirizzo' name="legalStreetAddress" value={formData.legalStreetAddress} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-4">
                                        <Form.Label>Località</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalLocality ? '#ced4da' : '#ff0000'}} placeholder='Inserisci località' name="legalLocality" value={formData.legalLocality} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-4">
                                        <Form.Label>Provincia</Form.Label>
                                        <Select
                                            isDisabled={props.isDisabled ? true : false}
                                            placeholder="Seleziona la provincia"
                                            name="legalProvince"
                                            value={italianProvinces.find(o => o.value === formData.legalProvince || o.label === formData.legalProvince) || null}
                                            onChange={(selected) => setFormData(prev => ({ ...prev, legalProvince: selected ? selected.value : '' }))}
                                            options={italianProvinces}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderColor: formData.legalProvince ? '#ced4da' : '#ff0000',
                                                    color: '#000000',
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>}
                                {!isLegalEqualsToOperativa && <Row className="mt-4">
                                    <Col className="col-xl-6">
                                        <Form.Label>CAP</Form.Label>
                                        <Form.Control type="text" style={{color: '#000000', borderColor: formData.legalPostalCode ? '#ced4da' : '#ff0000'}} placeholder='Inserisci CAP' name="legalPostalCode" value={formData.legalPostalCode} onChange={handleChange} disabled={props.isDisabled ? true : false} />
                                    </Col>
                                    <Col className="col-xl-6">
                                        <Form.Label>Paese</Form.Label>
                                        <Form.Control
                                            style={{
                                                color: 'rgba(108,117,125,0.6)',
                                                backgroundColor: '#f2f2f2',
                                                paddingLeft: "15px",
                                                marginTop: "8px",
                                                fontWeight: "normal"
                                            }}
                                            type="text"
                                            name="legalCountry"
                                            value="Italia"
                                            disabled={true}
                                            readOnly
                                        />
                                    </Col>
                                </Row>}
                            </Form>
                        </Card.Body>
                    </Card>
                    {!props.isDisabled && <div className="d-flex justify-content-end gap-4"><Link onClick={handleSaveClick} to="#" className="btn btn-primary ">Salva</Link></div>}
                </div>
            </Row>
        </>
    )
}

export default FormIDS